import React from 'react';
import { bonuses } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-16" data-mp="plsje24mow86">
      <div className="mx-auto max-w-6xl" data-id="element-17" data-mp="aujzm9neq52y">
        <SectionHeading eyebrow="Inclusi oggi gratis" title={<>
              5 bonus <span className="text-brand" data-id="element-19" data-mp="1un35lus01xc">esclusivi</span>
            </>} subtitle="Si aggiungono al kit senza costi extra, pensati per la tua tranquillità totale." data-id="element-18" data-mp="fu6baenl7d9n" />

        <ol className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="3o1v5efaefsp5">
          {bonuses.map((bonus, index) => <Reveal key={bonus.title} delay={index * 0.04} className="h-full" data-id="element-21" data-mp="3t06hyxs2whb2" data-mpi={index}>
              <li className="flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-bone transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-22" data-mp="1mai21uo2xsv7">
                <div className="relative border-b-2 border-ink bg-white" data-id="element-23" data-mp="1r78rv9pos2tt">
                  <img src={bonus.cover} alt={`Copertina del quaderno ${bonus.title}`} loading="lazy" className="mx-auto block h-56 w-full object-contain" data-id="element-24" data-mp="3icvdrgg4qs41" />
                  <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 font-display text-xs tracking-[0.1em] text-volt" data-id="element-25" data-mp="3n5etaiydnxbh">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="absolute right-4 top-4 rounded-full bg-volt px-3 py-1 font-display text-xs tracking-[0.1em] text-ink" data-id="element-26" data-mp="2uhixrhkjobga">
                    Gratis
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-27" data-mp="33ge4qvvexpkn">
                  <h3 className="font-display text-xl leading-tight text-ink" data-id="element-28" data-mp="nprllcosuxn9">
                    {bonus.title}
                  </h3>
                  <p className="mt-3 flex-1 text-base leading-relaxed text-ink/70" data-id="element-29" data-mp="iq55mvhl73ar">
                    {bonus.text}
                  </p>
                </div>
              </li>
            </Reveal>)}

          <Reveal delay={0.24} className="h-full" data-id="element-30" data-mp="3hgg67rtje0c5">
            <li className="flex h-full flex-col items-start justify-center rounded-2xl border-2 border-ink bg-brand p-8 text-white" data-id="element-31" data-mp="3ljunelt7omr6">
              <p className="font-display text-sm tracking-[0.14em] text-white/80" data-id="element-32" data-mp="3qhebsejmifwu">
                I 5 bonus
              </p>
              <p className="mt-3 font-display text-5xl leading-none" data-id="element-33" data-mp="2tqc1fh4m3ujk">
                Inclusi gratis
              </p>
              <p className="mt-4 text-base leading-relaxed text-white/85" data-id="element-34" data-mp="32t3gdqwp58fy">
                Si aggiungono oggi al kit completo, senza alcun costo
                aggiuntivo.
              </p>
            </li>
          </Reveal>
        </ol>
      </div>
    </section>;
}